import { DecimalRange } from '../../generated';

const filterNumbers = (values: (number | null | undefined)[]): number[] =>
    values.filter((value) => value === 0 || !!value) as number[];

const mergeDecimalRange = (
    { from: fromA, to: toA }: DecimalRange,
    { from: fromB, to: toB }: DecimalRange,
) => {
    const mergedRange: DecimalRange = {};
    const filteredNumbers = filterNumbers([fromA, toA, fromB, toB]);

    if (!filteredNumbers.length) return {};

    mergedRange.from = Math.min(...filteredNumbers);
    mergedRange.to = Math.max(...filteredNumbers);

    return mergedRange;
};

export { mergeDecimalRange };
